import styled from 'styled-components';
import { Badge, BADGE_VARIANTS } from 'ui/badge';
import { Add16 } from 'ui/icons/action/Add16';
import { Button, BUTTON_SIZES, BUTTON_VARIANTS } from 'ui/button';
import { body2, colors, spacing } from 'ui/theme';
import { Link } from 'ui/links';
import { useRuleBuilder } from '../RuleBuilder/hooks/useRuleBuilder';
import { RuleBlock, RuleBlockConsumer } from '../RuleBuilder/RuleBlock';
import { isFirstRuleFilledOut } from '../RuleBuilder/RuleBlock/RuleBlock.utils';

const StyledBadge = styled(Badge)`
  margin-right: ${spacing.plusHalf};
`;

const StyledHeader = styled.span`
  ${body2};
  color: ${colors.secondaryText};
`;

const StyledAdd = styled(Add16)`
  margin-right: ${spacing.quarter};
`;

const ExitRuleContainer = styled.div`
  overflow: hidden;
`;

const ExitRuleRow = styled.span`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const ExitRules = ({ goToConversionTab }: { goToConversionTab: () => void }) => {
  const { state, addRule, journeyConversionRuleIdx } = useRuleBuilder();
  const { rules } = state;
  const showAddExitRuleButton = isFirstRuleFilledOut(rules);
  return (
    <ExitRuleContainer>
      <StyledHeader>
        If any of the following rules are met, users will be removed from the journey regardless of
        what step they are actively on.{' '}
        <Link
          href="https://support.iterable.com/hc/en-us/articles/8120791290260"
          target="_blank"
          rel="noopener noreferrer"
          hasOpenNewTabIcon
        >
          Learn more
        </Link>
      </StyledHeader>
      {rules.map((rule, idx) => {
        return (
          <span key={rule?.id ? `r${rule.id}` : `i${idx}`}>
            <RuleBlock
              rule={rule}
              ruleIdx={idx}
              canDelete={rules.length > 1}
              canAddRules={journeyConversionRuleIdx !== idx}
              journeyConversionRuleIdx={journeyConversionRuleIdx}
              goToConversionTab={goToConversionTab}
              consumer={RuleBlockConsumer.ExitRules}
            />
            {idx < rules.length - 1 && <StyledBadge variant={BADGE_VARIANTS.READY}>OR</StyledBadge>}
          </span>
        );
      })}
      {showAddExitRuleButton && (
        <>
          <ExitRuleRow>
            <StyledBadge variant={BADGE_VARIANTS.READY}>OR</StyledBadge>
            <Button
              size={BUTTON_SIZES.SMALL}
              variant={BUTTON_VARIANTS.SECONDARY}
              onClick={addRule}
              data-test="ruleblocklist-add-exit-rule-button"
            >
              <StyledAdd />
              Exit rule
            </Button>
          </ExitRuleRow>
        </>
      )}
    </ExitRuleContainer>
  );
};
